import { useEffect, useState } from 'react';
import Select from 'react-select';
import { SUPPORTED_TYPES } from './hooks/useObjectRenderer';

interface Props {
    value?: string | null;
    onChange: (className: string | null) => void;
    label?: string;
}

export const SelectRemoteAbstractAction = ({
    value,
    onChange,
    label
}: Props) => {

    const [selectedOption, setSelectedOption] = useState<any>(null);
    const lista = SUPPORTED_TYPES

    useEffect(() => {
        if (value && lista?.length > 0) {
            const found = lista.find(
                item => item === value
            );

            if (found) {
                setSelectedOption({
                    value: found,
                    label: found,
                });
            }
        } else {
            setSelectedOption(null);
        }
    }, [value]);

    const options = (lista ?? []).map((item: any) => ({
        value: item,
        label: item,
    }));

    const handleChange = (option: any) => {
        setSelectedOption(option);
        onChange(option ? option.value : null);
    };

    return (
        <div>
            {label && label !== " " && <label>{label}</label>}
            <Select
                options={options}
                value={selectedOption}
                onChange={handleChange}
                isClearable
                placeholder="Selecciona un formulario remoto..."
                noOptionsMessage={() => "Sin coincidencias"}
            />
        </div>
    );
};
